// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3fIGH","content":"styles_content__3CB6H"};